module.exports = new __parcel__URL__("pin_avoir.b91c12d3.png").toString();